import { Avatar, Box } from '@mui/material'
import moment from 'moment'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  avatar: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    fontSize: theme.typography.caption.fontSize,
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
    background: 'none',
  },
  currentDay: {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}))

interface DateHeaderProps {
  label: string
  date: Date
}
const DateHeader: React.FC<React.PropsWithChildren<DateHeaderProps>> = ({
  label,
  date,
}) => {
  const { classes, cx } = useStyles()
  const isCurrentDay = moment(date).isSame(moment(), 'date')
  return (
    <Box display="flex" justifyContent={'center'} marginBottom={1}>
      <Avatar
        className={cx(classes.avatar, isCurrentDay && classes.currentDay)}
      >
        {label}
      </Avatar>
    </Box>
  )
}

export default DateHeader
